module.exports = __webpack_public_path__ + "img/DAY4-1.fae47683.jpg";